{
  "breadcrumb": {
    "root": "BLIKS IO",
    "dashboard": "My Work Environment",
    "recordingDashboard": "Recording Cockpit",
    "organization": "Organization Catalogs",
    "organigram": "Organigram",
    "processes": "Processes",
    "departments": "Departments",
    "myOrgFunctions": "My Functions",
    "functions": "Functions",
    "teams": "Teams",
    "systems": "Systems",
    "externalContacts": "External Contacts",
    "artifacts": "Documents",
    "orgMembers": "People",
    "allProcesses": "All Processes",
    "processEditor": "Process Editor",
    "myTasks": "My Tasks",
    "organizationSettings": "Settings",
    "dataSync": "Data sync",
    "initialSetup": "Initial Setup",
    "setupPending": "Setup Pending",
    "seatOverrun": "Organization Locked",
    "processMap": "Process Landscape",
    "processChains": "Process Chains",
    "systemLandscape": "System Landscape",
    "admin": "Admin",
    "tenants": "Tenants",
    "accounts": "Accounts",
    "users": "Users",
    "partnerContent": "Partner content",
    "createProcesses": "Create Processes",
    "shadowSystems": "Shadow Systems",
    "departmentsBulkUpload": "Bulk Upload Departments",
    "userManagement": "User Management",
    "apps": "Apps",
    "auditLogs": "Audit Logs",
    "recordingAnalytics": "Recording Analytics",
    "aiUsage": "AI Usage",
    "partner": "Partner",
    "leads": "Leads",
    "tasks": "Tasks",
    "helpCenter": "Customer Service",
    "supportTickets": "Support Tickets"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "No notifications"
  }
}
